
import React from 'react';
import completeStepsImageMobile from '../assets/OnlineMobile1.png'; // Mobile version
import completeStepsImageDesktop from '../assets/OnlineDesktop.png'; // Desktop version

function OnlineBook() {
  return (
    <div className="flex flex-col w-full p-4 md:px-16 bg-white">
  
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#FF9630] mb-2 text-center">How To Book A Bike Online</h2>
      <p className="text-gray-400 mb-8 text-center">Book a bike online in India from MyChoize in 4 Simple steps.</p>
      
      <div className="flex justify-center">
        <img
          src={completeStepsImageMobile}
          alt="How to Book a Bike (Mobile)"
          className="w-full h-auto rounded-lg block sm:hidden"
        />
        <img
          src={completeStepsImageDesktop}
          alt="How to Book a Bike (Desktop)"
          className="w-full h-auto rounded-lg hidden sm:block"
        />
      </div>
    </div>
  );
}

export default OnlineBook;
